var _path, _g, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgModuleInConstruction(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 401,
    height: 372,
    viewBox: "0 0 401 372",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M200.846 1.0147C248.782 7.80169 258.925 71.6924 293.368 105.721C328.263 140.197 401.425 149.21 400.491 198.26C399.555 247.462 327.066 255.081 289.911 287.341C257.83 315.195 243.258 369.157 200.846 371.599C157.956 374.069 133.364 326.37 100.9 298.226C63.8782 266.131 5.94496 247.001 0.899013 198.26C-4.27944 148.239 42.014 110.515 77.8112 75.2017C113.255 40.237 151.555 -5.96425 200.846 1.0147Z",
    fill: "url(#paint0_linear_2215_100109)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dd_2215_100109)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M164.781 61.2833C246.901 39.2792 321.425 105.878 343.893 189.729C360.69 252.414 292.32 291.696 230.927 308.146C165.864 325.58 80.8518 331.413 63.051 264.98C39.8231 178.292 79.8814 84.0319 164.781 61.2833Z",
    fill: "url(#paint1_linear_2215_100109)"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M237.405 124.594C239.073 124.594 240.672 125.271 241.85 126.474C243.029 127.678 243.691 129.311 243.691 131.013V163.105C243.691 164.807 243.029 166.44 241.85 167.643C240.672 168.847 239.073 169.523 237.405 169.523H205.975V252.963C205.975 254.665 205.313 256.298 204.134 257.501C202.955 258.705 201.357 259.381 199.689 259.381H174.545C172.878 259.381 171.279 258.705 170.101 257.501C168.922 256.298 168.259 254.665 168.259 252.963V169.523H133.686C132.019 169.523 130.42 168.847 129.242 167.643C128.063 166.44 127.4 164.807 127.4 163.105V147.816C127.401 146.625 127.727 145.457 128.34 144.443C128.954 143.43 129.833 142.611 130.877 142.078L165.116 124.594H237.405ZM205.975 137.431H168.083L139.972 151.783V156.686H180.831V246.544H193.403V156.686H205.975V137.431ZM231.119 137.431H218.547V156.686H231.119V137.431Z",
    fill: "#41435B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_2215_100109",
    x: 48.5391,
    y: 53.0368,
    width: 305.936,
    height: 278.63,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.254902 0 0 0 0 0.262745 0 0 0 0 0.356863 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2215_100109"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.254902 0 0 0 0 0.262745 0 0 0 0 0.356863 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_2215_100109",
    result: "effect2_dropShadow_2215_100109"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_2215_100109",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2215_100109",
    x1: 0.5,
    y1: 186,
    x2: 400.5,
    y2: 186,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1E95FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A46FB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2215_100109",
    x1: 52.0148,
    y1: 223.792,
    x2: 332.857,
    y2: 148.541,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F95C5E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB432"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgModuleInConstruction);
export default __webpack_public_path__ + "static/media/moduleInConstruction.8a4ccad7a1a4d92c7fdf4aff240b19a4.svg";
export { ForwardRef as ReactComponent };